export {
  type ExatoDigitalConfig,
  type ExatoDocCheck,
  type ExatoPartner,
  type UserValidationSocketResponse,
  cleanupExatoDocCheck,
  disconnectValidationSocket,
  generateCpfHash,
  getSocket,
  hashCpfExato,
  injectExatoDocCheckScript,
} from './common';
